// src/components/AuthPage.js
import React from "react";
import { Box, Button, Container } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AdminLoginForm from "./AdminLogin";
import "../../../src/globalCss.css";
import { Link } from "react-router-dom";

const auth_box = {
  logRegBox: {
    display: "flex",
    padding: "60px 60px 30px 60px",
    justifyContent: "center",
  },
  loginCol: {
    // width: "47%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  signupCol: {
    // width: "47%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  orDividertxt: {
    height: "80px",
    width: "100%",
    textAlign: "center",
    background: "#FFF",
    lineHeight: "1.4",
    padding: "5px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1",
    fontStyle: "italic",
  },
  captchaTxt: {
    fontSize: "14px",
    textAlign: "center",
    fontWeight: "500",
    letterSpacing: "0.3px",
    color: "#333333",
    marginBottom: "65px",
  },
  cantLogin: {
    fontSize: "16px",
    color: "#333333",
    fontWeight: "600",
    letterSpacing: "0px",
  },
};

const AdminAuthPage = () => {
  return (
    <Container maxWidth="xl">
      <Box className="dashboard_frame">
        <Box className="backBtnFrame">
          <Button
            className="backBtn"
            variant="contained"
            sx={{ marginBottom: 2 }}
            onClick={() => (window.location.href = "/")}
          >
            <ArrowBackIcon sx={{ marginRight: 1 }} />
            Back to Homepage
          </Button>
        </Box>

        <Box
          style={auth_box.logRegBox}
          sx={{ display: { xs: "block", sm: "block", md: "flex" } }}
        >
          <AdminLoginForm />
        </Box>
        <Box
          style={auth_box.captchaTxt}
          sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}
        >
          <Link to="/forgot-password" style={auth_box.cantLogin}>
            Can’t log in?
          </Link>
          <p>
            Secure Login with reCAPTCHA subject to <br /> Google &{" "}
            <a className="colorDarkTxt" href="/terms">
              TermsPrivacy
            </a>{" "}
          </p>
        </Box>
      </Box>
    </Container>
  );
};

export default AdminAuthPage;
